/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Subtext_Double_CheckInputs */



/**
* | output |
* | --- |
* | "Double-check the URL or head back to safety." |
*
* @param {Error_Notfound_Subtext_Double_CheckInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_subtext_double_check = /** @type {((inputs?: Error_Notfound_Subtext_Double_CheckInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Subtext_Double_CheckInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfe die URL oder geh zurück auf sicheren Boden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérifiez l'URL ou revenez en terrain sûr.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("请再确认一下网址，或者回到安全的地方。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("請再確認一次網址，或回到安全的地方。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("URL을 다시 확인하거나 안전한 곳으로 돌아가세요.")
	return /** @type {LocalizedString} */ ("Double-check the URL or head back to safety.")
});